var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "product-variants") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-113.000000, -105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "product-variants",
    transform: "translate(113.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 250,
    cy: 252,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Object-setting_line_b4",
    transform: "translate(100.000000, 104.000000)",
    stroke: "#000000",
    strokeWidth: 18.8679245
  }, /*#__PURE__*/React.createElement("line", {
    x1: 245.283019,
    y1: 188.846154,
    x2: 264.150943,
    y2: 188.846154,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.018868,188.846154 L320.754717,188.846154 C325.962264,188.846154 330.188679,193.076308 330.188679,198.288462 L330.188679,481.557692 C330.188679,486.769846 325.962264,491 320.754717,491 L9.43396226,491 C4.22641509,491 0,486.769846 0,481.557692 L0,198.288462 C0,193.076308 4.22641509,188.846154 9.43396226,188.846154 L226.415094,188.846154",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 113.207547,
    cy: 254.942308,
    rx: 28.3018868,
    ry: 28.3269231
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 226.415094,
    cy: 339.923077,
    rx: 28.3018868,
    ry: 28.3269231
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 132.075472,
    cy: 424.903846,
    rx: 28.3018868,
    ry: 28.3269231
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.1698113,
    y1: 254.942308,
    x2: 84.9056604,
    y2: 254.942308,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.509434,
    y1: 254.942308,
    x2: 283.018868,
    y2: 254.942308,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.018868,
    y1: 339.923077,
    x2: 254.716981,
    y2: 339.923077,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.1698113,
    y1: 339.923077,
    x2: 198.113208,
    y2: 339.923077,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.1698113,
    y1: 424.903846,
    x2: 103.773585,
    y2: 424.903846,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.377358,
    y1: 424.903846,
    x2: 283.018868,
    y2: 424.903846,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.113208,160.519231 L198.113208,47.2115385 C198.113208,41.9993846 202.339623,37.7692308 207.54717,37.7692308 L433.962264,37.7692308 C439.169811,37.7692308 443.396226,41.9993846 443.396226,47.2115385 L443.396226,349.365385 C443.396226,354.577538 439.169811,358.807692 433.962264,358.807692 L358.490566,358.807692",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.320755,39.3460962 L258.877358,1.60519231 C260.377358,0.594865385 262.198113,0 264.150943,0 L490.566038,0 C495.773585,0 500,4.23015385 500,9.44230769 L500,311.596154 C500,314.85375 498.349057,317.733654 495.839623,319.423827 L439.188679,357.221385",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 497.396226,
    y1: 2.91767308,
    x2: 440.745283,
    y2: 40.7246731,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.660377,
    y1: 94.4230769,
    x2: 405.660377,
    y2: 179.403846,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.660377,
    y1: 198.288462,
    x2: 405.660377,
    y2: 217.173077,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.3396226,
    y1: 0,
    x2: 94.3396226,
    y2: 47.2115385,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.3396226,
    y1: 84.9807692,
    x2: 94.3396226,
    y2: 132.192308,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.377358,
    y1: 66.0961538,
    x2: 113.207547,
    y2: 66.0961538,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.4716981,
    y1: 66.0961538,
    x2: 28.3018868,
    y2: 66.0961538,
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.7130944a3644fef8f685b530dfd68d42.svg";
export { ForwardRef as ReactComponent };